module.exports = __webpack_public_path__ + "img/6.764c022f.png";